import {
	TableCell,
	TableFooter,
	TableRow,
	withStyles,
	WithStyles,
} from '@material-ui/core';
import {Component, ReactNode} from 'react';

// TODO: remove use of AppStyles, if needed create new file
import {printHours} from 'Utilities';

import trackingTableFooterStyles from './TrackingTableFooterStyles';

interface Props extends WithStyles<typeof trackingTableFooterStyles> {
	actualSum: number;
	requiredSum: number;
}

class TrackingTableFooter extends Component<Props> {
	public constructor(props: Props) {
		super(props);
	}

	public render(): ReactNode {
		return (
			<TableFooter>
				<TableRow>
					<TableCell colSpan={4} />
					<TableCell>Summen: </TableCell>
					<TableCell>{printHours(this.props.requiredSum)}</TableCell>
					<TableCell>{printHours(this.props.actualSum)}</TableCell>
					<TableCell>
						{printHours(
							this.props.actualSum - this.props.requiredSum
						)}
					</TableCell>
					<TableCell colSpan={4} />
				</TableRow>
			</TableFooter>
		);
	}
}

export default withStyles(trackingTableFooterStyles)(TrackingTableFooter);
